import { Component, ErrorInfo, ReactNode } from 'react';
import { Sentry } from '../config/sentry';

class ErrorBoundary extends Component<
  {
    fallback: ((error: Error) => ReactNode) | ReactNode;
    children: ReactNode;
  },
  { error: Error | null }
> {
  state: { error: Error | null } = {
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(error);
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
    });
  }

  render() {
    const { fallback, children } = this.props;
    const { error } = this.state;

    if (error !== null)
      return typeof fallback === 'function' ? fallback(error) : fallback;

    return children;
  }
}

export default ErrorBoundary;
